import { render, staticRenderFns } from "./PowerGrammarFixHead.vue?vue&type=template&id=297f9894&scoped=true"
import script from "./PowerGrammarFixHead.vue?vue&type=script&lang=js"
export * from "./PowerGrammarFixHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f9894",
  null
  
)

export default component.exports